import React, { useEffect, useMemo, useState } from "react";
import { Select } from "@mantine/core";
import _ from "lodash";
import { useServerApi } from "../hooks/userServerApi";
import { idOf, rankOptions } from "../helpers/promotionProgress";
import FormReadOnlyField from "./formReadOnlyField";
import { isWidgetReadOnly } from "../helpers/formReadOnly";

const PromotionRankSelect = ({
  form: mainForm,
  name = "consultantInfo.promotionRankCode",
  label = "Promotion Rank",
  readOnly = false,
  readonly = false,
  disabled = false,
  ...props
}) => {
  const [api] = useServerApi();
  const [track, setTrack] = useState(null);
  const trackRef = _.get(mainForm.values, "consultantInfo.promotionTrack");
  const trackId = idOf(trackRef);
  const currentCode = _.get(mainForm.values, name) || "";

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!trackId) {
        if (!cancelled) setTrack(null);
        return;
      }
      if (typeof trackRef === "object" && Array.isArray(trackRef.ranks)) {
        if (!cancelled) setTrack(trackRef);
        return;
      }
      const data = await api.getById({
        apiEntity: "promotionTrack",
        id: trackId,
      });
      if (!cancelled) setTrack(data || null);
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [trackId]);

  const options = useMemo(() => rankOptions(track), [track]);
  const locked = isWidgetReadOnly({
    disabled,
    readOnly,
    readonly,
    form: mainForm,
  });

  useEffect(() => {
    if (locked) return;
    if (!trackId) {
      if (currentCode) mainForm.setFieldValue(name, "");
      return;
    }
    if (!options.length) return;
    const exists = options.some((option) => option.value === currentCode);
    if (!exists) {
      mainForm.setFieldValue(name, options[0].value);
    }
  }, [locked, trackId, options.map((option) => option.value).join("|")]);

  if (locked) {
    const optionLabel =
      options.find((option) => option.value === currentCode)?.label ||
      currentCode ||
      "-";
    return <FormReadOnlyField label={label} value={optionLabel} />;
  }

  return (
    <Select
      label={label}
      data={options}
      value={currentCode || null}
      disabled={!trackId}
      searchable
      clearable
      onChange={(value) => mainForm.setFieldValue(name, value || "")}
      {...props}
    />
  );
};

export default PromotionRankSelect;
